import progressIndicator from "./progressIndicator.component";

const progressIndicatorModule = angular
  .module("app.components.progressIndicator", [])
  .component("progressIndicator", progressIndicator);

export default progressIndicatorModule;



// WEBPACK FOOTER //
// ./src/components/progressIndicator/progressIndicator.module.js